import React, { useEffect, useState, useCallback } from 'react';
import { Edit, Add, ArrowBack, FileDownload } from "@mui/icons-material";
import api from '../../services/api';
import styles from '../../assets/styles/LayoutShared.module.css';
import { formatarDataBR } from '../../utils/formatters';
import ProjetoForm from './ProjetoForm';
import ProjetoExportarModal from './ProjetoExportarModal';

const ProjetosList = () => {
  const isAdmin = localStorage.getItem('modulo') === 'admin';
  const [projetos, setProjetos] = useState<any[]>([]);
  const [formOpen, setFormOpen] = useState(false);
  const [projetoEditando, setProjetoEditando] = useState<any>(null);
  const [projetoExportando, setProjetoExportando] = useState<any>(null);

  const fetchProjetos = useCallback(() => {
    api.get('/pesca/projetos').then(res => setProjetos(res.data.data));
  }, []);

  useEffect(() => {
    fetchProjetos();
  }, [fetchProjetos]);

  const handleNovo = () => {
    setProjetoEditando(null);
    setFormOpen(true);
  };

  const handleEditar = (projeto: any) => {
    setProjetoEditando(projeto);
    setFormOpen(true);
  };

  const handleSalvo = () => {
    setFormOpen(false);
    fetchProjetos();
  };

  return (
    <div className={styles.container}>
      <div className={styles.headerTitle}>
        <h1 className={styles.greenTitle}>Projetos Ativos</h1>

        <div className={styles.actionsHeader}>
          <p style={{ alignSelf: 'center', fontSize: '0.9rem', color: '#666', marginRight: '10px' }}>
            Qtd: <span style={{ fontWeight: 'bold', color: 'var(--green-700)' }}>{projetos.length}</span>
          </p>

          {isAdmin && (
            <button className={styles.blueBtn} onClick={handleNovo} title="Adicionar Novo">
              <Add />
            </button>
          )}
          <button className={styles.blueBtn} onClick={() => window.history.back()} title="Voltar">
            <ArrowBack />
          </button>
        </div>
      </div>

      <div className={styles.tableWrapper}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Nome do Projeto</th>
              <th>Data Início</th>
              <th>Status</th>
              <th style={{ textAlign: 'center' }}>Ações</th>
            </tr>
          </thead>
          <tbody>
            {projetos.map((p) => (
              <tr key={p.uid_pesca_projeto}>
                <td><strong style={{ color: '#444' }}>{p.nome}</strong></td>
                <td>{formatarDataBR(p.data_inicio)}</td>
                <td>
                  {(() => {
                    // data_fim só encerra o projeto quando a data já
                    // chegou — uma data futura é um encerramento
                    // programado, o projeto continua em andamento até lá.
                    // "Hoje" é a data local de quem está olhando a tela —
                    // comparação simples de string YYYY-MM-DD, sem
                    // envolver Date pra não sofrer de fuso horário (a
                    // coluna é DATEONLY, sempre chega como string "crua").
                    const hoje = new Date();
                    const hojeISO = `${hoje.getFullYear()}-${String(hoje.getMonth() + 1).padStart(2, '0')}-${String(hoje.getDate()).padStart(2, '0')}`;
                    const dataFimISO = p.data_fim ? String(p.data_fim).slice(0, 10) : null;
                    const jaEncerrou = dataFimISO !== null && dataFimISO <= hojeISO;
                    const encerramentoProgramado = dataFimISO !== null && dataFimISO > hojeISO;
                    const cor = jaEncerrou ? '#f75a68' : encerramentoProgramado ? '#e08a00' : '#00b37e';
                    const texto = jaEncerrou
                      ? `Encerrado em ${formatarDataBR(p.data_fim)}`
                      : encerramentoProgramado
                        ? `Encerra em ${formatarDataBR(p.data_fim)}`
                        : 'Em andamento';
                    return <span style={{ color: cor, fontWeight: 'bold' }}>{texto}</span>;
                  })()}
                </td>
                <td>
                  <div style={{ display: 'flex', gap: '8px', justifyContent: 'center' }}>
                    {isAdmin && (
                      <Edit fontSize="small" style={{ color: '#03c9fe', cursor: 'pointer' }} onClick={() => handleEditar(p)} titleAccess="Editar" />
                    )}
                    {/* Exportar: membros do projeto (versão pseudonimizada) e admin; a lista já vem só com os projetos do usuário */}
                    <FileDownload fontSize="small" style={{ color: '#00b37e', cursor: 'pointer' }} onClick={() => setProjetoExportando(p)} titleAccess="Exportar dados (.xlsx ou .zip de CSVs)" />
                  </div>
                </td>
              </tr>
            ))}
            {projetos.length === 0 && (
              <tr>
                <td colSpan={4} style={{ textAlign: 'center', padding: '20px', color: '#999' }}>
                  Nenhum projeto cadastrado.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {formOpen && (
        <ProjetoForm
          projeto={projetoEditando}
          onClose={() => setFormOpen(false)}
          onSaved={handleSalvo}
        />
      )}

      {projetoExportando && (
        <ProjetoExportarModal
          projeto={projetoExportando}
          onClose={() => setProjetoExportando(null)}
        />
      )}
    </div>
  );
};

export default ProjetosList;
